import { ILogger } from './ilogger';

export class ConsoleLogger implements ILogger {
  private executeQueue: (() => void)[] = [];

  private pendingInit = true;

  private isEnabled!: boolean;

  constructor(private name: string) {}

  private formatter(message: string) {
    if (this.name) {
      return `[${this.name}] ${message}`;
    }

    return message;
  }

  private execOrQueue(func: () => void) {
    if (this.pendingInit) {
      this.executeQueue.push(func);
    } else if (this.isEnabled) {
      func();
    }
  }

  groupStart(title: string) {
    this.execOrQueue(() => console.group(this.formatter(title)));
  }

  groupEnd() {
    this.execOrQueue(() => console.groupEnd());
  }

  log(message: string, ...optionalParams: any[]): void {
    this.execOrQueue(() =>
      console.log(this.formatter(message), ...optionalParams),
    );
  }

  warn(message: string, ...optionalParams: any[]): void {
    this.execOrQueue(() =>
      console.warn(this.formatter(message), ...optionalParams),
    );
  }

  info(message: string, ...optionalParams: any[]): void {
    // tslint:disable-next-line:no-console
    this.execOrQueue(() =>
      console.info(this.formatter(message), ...optionalParams),
    );
  }

  error(message: string, ...optionalParams: any[]): void {
    this.execOrQueue(() =>
      console.error(this.formatter(message), ...optionalParams),
    );
  }

  enable() {
    this.isEnabled = true;
    this.consumeQueue(true);
  }

  disable() {
    this.isEnabled = false;
    this.consumeQueue(false);
  }

  private consumeQueue(shouldConsume: boolean) {
    if (this.pendingInit) {
      this.pendingInit = false;
      if (shouldConsume) {
        this.executeQueue.forEach((func) => {
          func();
        });
      }

      this.executeQueue = [];
    }
  }
}
